<template>
  <div class="competency-participants">
    <modal :title="title" v-if="modal" @close="switchModal()">
      <participant-package v-if="isPackageModal"
        @close="switchModal()" :participant="editableParticipant"/>
      <participant v-else @close="switchModal()" :data="editableParticipant"/>
    </modal>
    <div class="actions-add" v-if="permissionsStatus.isParticipantCreateAllowed">
      <button class="ccs-button ccs-button--white" @click="switchModal()">
        <img src="@/assets/icons/add.svg" alt="" class="button-icon">
        Добавить
      </button>
    </div>
    <ccs-table :data="participants" :columnsDefs="columnsDefs"
      :defaultActions="defaultActions" @edit="switchModal" @delete="removeParticipant">
      <template v-slot:full_name="props">
        <div class="participant-full_name">
          <i class="participant-last_name">
            {{ props.row.last_name }}
          </i>
          <i>{{ `${props.row.first_name} ${props.row.patronymic}` }}</i>
        </div>
      </template>
      <template v-slot:role="props">
        {{ props.isEmpty ? 'Роль отсутствует' : props.row.role.name }}
      </template>
      <template v-slot:packages="props">
        <div v-if="!props.row.packages.data.length || props.row.packages.data.length === 0"
          class="participant-package">
          <img v-if="permissionsStatus.isPackageParticipantAllowed"
            src="@/assets/icons/add.svg" alt="" 
            @click="switchModal(props.row, true)">
        </div>
        <div v-else class="participant-package">
          <img v-if="permissionsStatus.isPackageParticipantAllowed"
            src="@/assets/icons/delete.svg" alt=""
            @click="removePackage(props.row)">
          {{ `${props.row.packages.data[0].name}` }}
        </div>
      </template>
    </ccs-table>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import Table from '@/components/Table.vue';
import Modal from '@/components/Modal.vue';

import Participant from '@/components/modals/participants/Participant.vue';
import ParticipantPackage from '@/components/modals/participants/ParticipantPackage.vue';

export default {
  name: 'Participants',
  components: {
    'ccs-table': Table,
    Modal,
    Participant,
    ParticipantPackage,
  },
  data() {
    return {
      modal: false,
      isPackageModal: false,
      editableParticipant: null,
      titles: {
        newParticipant: 'Добавление участника',
        editParticipant: 'Редактирование участника',
        newPackage: 'Привязка пакета',
      },
      columnsDefs: [{
        name: `full_name`,
        title: 'ФИО',
        prop: 'name',
        type: 'full_name',
      }, {
        name: `email`,
        title: `Email`,
        prop: `email`,
        fontStyle: 'secondary',
      }, {
        name: `role`,
        title: `Роль`,
        prop: `role`,
        fontStyle: 'secondary',
      }, {
        name: `label`,
        title: `Тег`,
        prop: `label`,
        emptyText: 'Не назначен',
      }, {
        name: `phone`,
        title: `Телефон`,
        prop: `phone`,
      }, {
        name: `subject`,
        title: `Регион/Компания/ВУЗ`,
        prop: `subject`,
      }, {
        name: `institution`,
        title: `Образовательная организация`,
        prop: `institution`,
      }, {
        name: `packages`,
        title: `Пакет`,
        align: 'center',
      }],
    };
  },
  computed: {
    ...mapState('events', ['event']),
    ...mapState('skills', ['skill']),
    ...mapState('users', ['participants']),
    ...mapGetters('session', ['permissionsStatus']),
    title() {
      if (this.isPackageModal) return this.titles.newPackage;
      return this.editableParticipant ? this.titles.editParticipant : this.titles.newParticipant;
    },
    defaultActions() {
      return {
        isTitleHidden: true,
        edit: this.permissionsStatus.isParticipantUpdateAllowed,
        delete: this.permissionsStatus.isParticipantDeleteAllowed,
      };
    },
  },
  methods: {
    ...mapActions('users', ['getParticipants', 'updateParticipant', 'deleteParticipant']),
    ...mapActions('packages', ['deletePackageFromParticipant']),
    switchModal(editableParticipant = null, isPackage = false) {
      this.editableParticipant = !editableParticipant ?
        editableParticipant : Object.assign({}, editableParticipant);
      this.isPackageModal = isPackage;
      this.modal = !this.modal;
    },
    async removeParticipant(participant) {
      try {
        await this.deleteParticipant(participant.id);
        this.$toasted.success('Удаление успешно');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async removePackage(participant) {
      try {
        await this.deletePackageFromParticipant({
          participantID: participant.id,
          packageID: participant.packages.data[0].id,
        });
        this.$toasted.success('Пакет удален');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    parseFullName(participant) {
      let rawFullName = participant.full_name.split(' ');
      participant.last_name = rawFullName[0];
      participant.first_name = rawFullName[1];
      participant.patronymic = rawFullName[2];
    }
  },
  async mounted() {
    await this.getParticipants();
  },
};
</script>

<style lang="scss" scoped>
.competency-participants {
  min-height: 100%;
  min-width: 100%;

  .participant{ 

    &-full_name {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }

    &-last_name {
      width: 100%;
      margin-bottom: 5px;
      font-weight: bold;
    }

    &-package {
      display: flex;
      justify-content: center;
      align-items: center;

      > img {
        margin-top: -2px;
        padding: 0 10px;

        &:hover {
          cursor: pointer;
        }

      }

    }

  }

  .actions-add {
    margin-bottom: 30px;
  }

}
</style>
